import { NOT_ASSIGNED } from 'constants/constants';
import { Subtype } from 'services/EpdClient';

export default function getSubtypeLabel(subtype: Subtype | any, strict: boolean = true): string {
  switch (subtype) {
    case Subtype.Specific:
      return 'Specific (single product)';
    case Subtype.Average:
      return 'Average (multiple products)';
    case Subtype.Representative:
      return 'Representative (Sector EPD)';
    case Subtype.Template:
      return 'Template (product not yet on the market)';
    default:
      if (strict) {
        throw new Error('Invalid subtype has been passed.');
      }

      return subtype ? (Number.isInteger(subtype) ? String.fromCharCode(subtype) : subtype) : NOT_ASSIGNED;
  }
}
